<template>
  <div class="page-completed">
    <div class="position-relative">
      <section
        class="section-shaped"
      >
        <div class="container">
          <div
            v-if="validInit"
            class="row row-grid justify-content-center"
          >
            <div class="col-lg-12 text-center">
              <div class="d-flex flex-column justify-space-between align-center">
                <div class="flex-item item">
                  <img
                    v-lazy="'img/icons/common/success.png'"
                    class="card-img"
                  >
                </div>
              </div>
              <h1 class="display-3 ">
                {{ textCompletedTitle || $t('views.completed.title') }}
              </h1>
              <div>
                <p class="lead">
                  {{ completedDescription }}
                </p>
                <base-button
                  v-if="externalLink && hasRedirectButtonText"
                  @click="redirectLink()"
                  class="btn btn-link mb-3 mb-sm-0 my-3"
                >
                  {{ textButtonCompletedActionRedirect }}
                </base-button>
              </div>
            </div>
          </div>
          <slide-y-up-transition v-if="alert.show">
            <div class="col-lg-12 text-center alert-message">
              <h1 class="display-3 ">
                {{ alert.title }}
              </h1>
              <div class="d-flex flex-column justify-space-between align-center">
                <div class="flex-item item">
                  <img
                    v-lazy="'img/icons/common/fail.png'"
                    class="card-img"
                  >
                </div>
              </div>
              <p>{{ alert.message }}</p>
              <base-button
                @click="alert.action()"
                class="btn btn-primary mb-3 mb-sm-0 my-3"
              >
                {{ alert.textButton }}
              </base-button>
            </div>
          </slide-y-up-transition>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { SlideYUpTransition } from 'vue2-transitions'
import IncogniaWebSdk from '@incognia/web-sdk'

export default {
  name: 'CompletedView',
  components: {
    SlideYUpTransition
  },
  data() {
    return {
      textCompletedTitle: '',
      textCompletedDescription: '',
      textCompletedDescriptionRedirect: '',
      textButtonCompletedActionRedirect: '',
      validInit: false,
      externalLink: null,
      alert: {
        show: false,
        type: '',
        title: '',
        message: '',
        action: false,
        textButton: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'riskDevice',
      'riskDeviceId',
      'client'
    ]),
    completedDescription() {
      const templateDescription = this.textCompletedDescription || this.textCompletedDescriptionRedirect
      if (templateDescription) {
        return templateDescription
      }

      return this.externalLink
        ? this.$t('views.completed.messageLinkRedirect')
        : this.$t('views.completed.message')
    },
    hasRedirectButtonText() {
      return typeof this.textButtonCompletedActionRedirect === 'string'
        ? this.textButtonCompletedActionRedirect.trim().length > 0
        : Boolean(this.textButtonCompletedActionRedirect)
    }
  },
  created() {
    this.validStep()
    this.initRiskDevice()
  },
  methods: {
    ...mapActions([
      'validStepTransaction',
      'resetProcessUser'
    ]),
    async validStep() {
      const { success, data } = await this.validStepTransaction({ step: 'completed' })
      if (success) {
        const { data: dataValid } = data
        if (dataValid.success) {
          this.validInit = true

          if (this.client['text-completed-title']) {
            this.textCompletedTitle = this.client['text-completed-title']
          }
          if (this.client['text-completed-description']) {
            this.textCompletedDescription = this.client['text-completed-description']
          }
          if (this.client['text-completed-description-redirect']) {
            this.textCompletedDescriptionRedirect = this.client['text-completed-description-redirect']
          }
          if (this.client['text-button-completed-action-redirect']) {
            this.textButtonCompletedActionRedirect = this.client['text-button-completed-action-redirect']
          } else if (this.client.textButtonCompletedActionRedirect) {
            this.textButtonCompletedActionRedirect = this.client.textButtonCompletedActionRedirect
          }
          if (dataValid.externalLink) {
            this.externalLink = dataValid.externalLink
            this.redirectExternal()
          }
        } else {
          this.alert = {
            show: true,
            type: 'danger',
            title: 'Opss',
            message: this.$t(`errors.${dataValid.message}`),
            action: this.restartProcess,
            textButton: 'Reiniciar o processo',
            img: 'fail'
          }
        }
      } else {
        this.alert = {
          show: true,
          type: 'danger',
          title: 'Opss',
          message: this.$t('errors.error_default_restart_transaction'),
          action: this.restartProcess,
          textButton: 'Reiniciar o processo',
          img: 'fail'
        }
      }
    },
    initRiskDevice() {
      if (this.riskDevice) {
        IncogniaWebSdk.init({ appId: this.riskDeviceId })
      }
    },
    async redirectExternal() {
      setTimeout(() => {
        window.location.href = this.externalLink
      }, 6000)
    },
    async redirectLink() {
      window.location.href = this.externalLink
    },
    async restartProcess() {
      const link = await this.resetProcessUser()
      this.$router.push({
        path: '/',
        query: {
          y: link
        }
      })
    }
  }
}
</script>
<style lang="scss">
.page-completed {
  .card-img {
    max-width: 180px;
    max-height: 180px;
    margin: .8rem 0;
  }
}
</style>
